module.exports = __webpack_public_path__ + "static/media/info-icon.699f8c86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-icon.svg
// module id = 271
// module chunks = 0